import React from 'react';

import styles from './alertStaticStyles';

const AlertStatic = ({ children }) => <div className={styles.alertStatic}>{children}</div>;

export default AlertStatic;
